import moment from 'moment';

import {
  setInSessionStorage,
  getFromSessionStorage,
  getEntries,
  removeFromSessionStorage,
} from 'Client/session-storage-api/sessionStorageApi';

const cacheFrontPrefix = 'CACHE_FRONT__';

export function getQueryResult(cacheKey, customerNeolaneId = '#') {
  if (!cacheKey) {
    return null;
  }
  try {
    const { expirationDate, result } = JSON.parse(
      getFromSessionStorage(cacheFrontPrefix + cacheKey + customerNeolaneId) || '{}',
    );

    if (!expirationDate) {
      return null;
    }
    if (moment(expirationDate).isBefore(moment())) {
      removeFromSessionStorage(cacheFrontPrefix + cacheKey + customerNeolaneId);
      return null;
    }

    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
}

export function setQueryResult({
  cacheKey,
  cacheExpirationDate = moment().add('2', 'minutes'),
  result,
  customerNeolaneId = '#',
}) {
  try {
    setInSessionStorage(
      cacheFrontPrefix + cacheKey + customerNeolaneId,
      JSON.stringify({ expirationDate: cacheExpirationDate, result }),
    );
  } catch (e) {
    console.error(e);
  }
  return null;
}

export function clearAllCacheFront() {
  getEntries().forEach(([key]) => {
    if (key.startsWith(cacheFrontPrefix)) {
      removeFromSessionStorage(key);
    }
  });
}
